import styled from "styled-components";

export const StyledWrapper = styled.div`
  margin-inline: auto;
  max-width: 82.5rem;

  @media (max-width: 84.5rem) {
    padding-inline: 2rem;
  }
`;
